import { render, staticRenderFns } from "./TopBarNavItem.vue?vue&type=template&id=043eb8a2&scoped=true&"
import script from "./TopBarNavItem.vue?vue&type=script&lang=ts&"
export * from "./TopBarNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./TopBarNavItem.vue?vue&type=style&index=0&id=043eb8a2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043eb8a2",
  null
  
)

export default component.exports